var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoReadonly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.67 21.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003189;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.22,0H3.3C1.51-.03.04,1.39,0,3.17v14.91c.04,1.79,1.51,3.2,3.3,3.17h8.92c1.79.03,3.26-1.39,3.3-3.17V3.17C15.48,1.39,14.01-.03,12.22,0ZM14.09,18.09c-.04.99-.87,1.77-1.87,1.74H3.3c-.99.03-1.83-.74-1.87-1.74v-4.22s0,0,0,0V3.17c.04-.99.87-1.77,1.87-1.74h8.92c.99-.03,1.83.74,1.87,1.74v4.22s0,0,0,0v10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8916",
    "data-name": "Path 8916",
    className: "cls-1",
    d: "M3.44,5.65h8.81c.4,0,.72-.32.72-.71s-.32-.72-.71-.72H3.44c-.4,0-.72.32-.72.71s.32.72.71.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8917",
    "data-name": "Path 8917",
    className: "cls-1",
    d: "M3.44,9.42h3.93c.4,0,.72-.32.72-.71s-.32-.72-.71-.72h-3.94c-.4,0-.72.32-.72.71s.32.72.71.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918",
    "data-name": "Path 8918",
    className: "cls-1",
    d: "M3.44,13.19h3.93c.4,0,.72-.32.72-.72s-.32-.72-.72-.72h-3.93c-.4,0-.72.32-.72.72s.32.72.72.72h0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.43,10.63c0,1.95-1.58,3.52-3.52,3.52s-3.52-1.58-3.52-3.52c0-1.95,1.58-3.52,3.52-3.52s3.52,1.58,3.52,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.91,14.91c-2.36,0-4.27-1.92-4.27-4.27s1.92-4.28,4.27-4.28,4.28,1.92,4.28,4.28-1.92,4.27-4.28,4.27ZM13.91,7.86c-1.53,0-2.77,1.25-2.77,2.78s1.24,2.77,2.77,2.77,2.78-1.24,2.78-2.77-1.25-2.78-2.78-2.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.92,17.4c-.19,0-.38-.07-.53-.22l-3.5-3.5c-.29-.29-.29-.77,0-1.06s.77-.29,1.06,0l3.5,3.5c.29.29.29.77,0,1.06-.15.15-.34.22-.53.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918-2",
    "data-name": "Path 8918",
    className: "cls-1",
    d: "M3.44,16.96h8.81c.4,0,.72-.32.72-.72s-.32-.72-.72-.72H3.44c-.4,0-.72.32-.72.72s.32.72.72.72h0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReadonly);
export default __webpack_public_path__ + "static/media/ico-readonly.67bbd9170169b23e0bc0dacfaade221e.svg";
export { ForwardRef as ReactComponent };